import React from "react";
import { zodResolver } from "@hookform/resolvers/zod";

import { z } from "zod";
import { useForm } from "react-hook-form";

import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/uiComponents/components/ui/form";
import { Input } from "@/uiComponents/components/ui/input";

import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@/store/store";
import { setLoading } from "@/store/redux/appSlice";

import { updateItemProps } from "@/types/organization";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/uiComponents/components/ui/dialog";

import { ErrorHelper } from "@/utils/errorHelper";
import { toastMessage } from "@/utils/toastHelper";
import { ReusableButton } from "@/reusable/reusableButton";
import { itemSchema } from "@/utils/schemaHelper";
import { getItemApi, updateItemApi } from "@/modules/organizationServices";
import { setItems, updateItem } from "@/store/redux/organization/itemSlice";
import { ItemError, ItemSuccess } from "@/enums/errorMessages";

const UpdateItem: React.FC<updateItemProps> = ({ onClose, isOpen, item }) => {
  if (!isOpen) return null;
  const dispatch = useDispatch();

  const loading = useSelector((state: RootState) => state.app.loading);

  const form = useForm<z.infer<typeof itemSchema>>({
    resolver: zodResolver(itemSchema),
    mode: "onChange",
    defaultValues: {
      name: item.name,
      organization: item.organization,
    },
  });

  const getItems = async () => {
    try {
      const res = await getItemApi();
      const response = res.items;
      if (response != undefined) {
        const items = Array.isArray(response) ? response : [response];
        dispatch(setItems(items));
      }
    } catch (error) {
      const actualError = ErrorHelper(error);
      const message = Array.isArray(actualError) ? actualError[0] : actualError;
      toastMessage("error", message);
    }
  };

  const onSubmit = async (values: z.infer<typeof itemSchema>) => {
    if (loading) return;
    dispatch(setLoading(true));

    try {
      if (!item.id) {
        throw new Error(ItemError.ITEM_ID_REQUIRED);
        toastMessage("error", ItemError.ITEM_ID_REQUIRED);
      }

      await updateItemApi(values, item.id);
      getItems();
      {
        dispatch(
          updateItem({
            id: item.id,
            ...values,
          }),
        );
      }

      onClose();

      toastMessage("success", ItemSuccess.ITEM_UPDATED);
    } catch (error) {
      const actualError = ErrorHelper(error);
      const message = Array.isArray(actualError) ? actualError[0] : actualError;
      toastMessage("error", message);
    } finally {
      dispatch(setLoading(false));
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[500px]">
        <DialogHeader>
          <DialogTitle>Edit Item</DialogTitle>
        </DialogHeader>

        <Form {...form}>
          <form
            onSubmit={form.handleSubmit(onSubmit)}
            className="space-y-6 mt-5"
          >
            <FormField
              control={form.control}
              name="name"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>Name</FormLabel>

                  <FormControl>
                    <Input
                      className="bg-white"
                      {...field}
                      placeholder="Enter item name"
                    />
                  </FormControl>

                  <FormMessage className="text-xs mt-1" />
                </FormItem>
              )}
            />
            <FormField
              control={form.control}
              name="organization"
              render={({ field }) => (
                <FormItem className="max-h-13">
                  <FormLabel hidden>Organization</FormLabel>
                  <FormControl>
                    <Input hidden {...field} value={item.organization} />
                  </FormControl>
                </FormItem>
              )}
            />

            <div className="flex justify-center mt-4 mr-2">
              <ReusableButton
                label="Update"
                className=" mt-5 mb-2 "
                loading={loading}
              />
            </div>
          </form>
        </Form>
      </DialogContent>
    </Dialog>
  );
};
export default UpdateItem;
